<template>
  <div class="fshr-mapItemTooltip-content">
    <div
      v-if="content.imageSrc"
      class="fshr-mapItemTooltip-image"
      :style="{ 'background-image': 'url(' + content.imageSrc + ')' }"
    />
    <div>
      <StarRating
        v-if="content.stars"
        :rating="content.stars.length"
        :isSelectable="false"
      />
    </div>
    <p class="fshr-mapItemTooltip-title">{{ content.title }}</p>
    <p v-if="content.tripadvisorSrc" class="fshr-mapItemTooltip-tripadvisor">
      <img :src="content.tripadvisorSrc" alt="" />
      <span
        v-if="content.tripadvisorText"
        class="fshr-mapItemTooltip-tripadvisorText"
      >
        {{ content.tripadvisorText }}
      </span>
    </p>
    <ol v-if="locations.length" class="fshr-breadcrumb">
      <li
        v-for="(locationName, locationNameIdx) in locations"
        class="fshr-breadcrumb-item"
        :key="locationNameIdx"
      >
        {{ locationName }}
      </li>
    </ol>
    <p
      v-if="content.pictograms && content.pictograms.length"
      class="fshr-searchResults-icons"
    >
      <span
        v-for="(pictogram, pictogramIdx) in content.pictograms"
        class="js-tooltip fshr-icon fshr-icon--circled"
        :class="{ [pictogram.icon]: pictogram.icon }"
        :title="pictogram.title || ''"
        :key="pictogramIdx"
      />
    </p>
    <p v-if="content.priceText" class="fshr-paragraph fshr-paragraph--last">
      <strong>
        <span class='fshr-priceLabel' v-html="content.priceText.label"></span>
        <span class='fshr-price' v-html="content.priceText.price"></span>
      </strong>
    </p>
  </div>
</template>

<script>
import StarRating from "./common/StarRating.vue";

export default {
  name: "HotelMarkerDetailsInner",
  components: {
    StarRating,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    locations() {
      return (this.content.locations || [])
        .map((item) => item.title)
        .filter(Boolean);
    },
  },
};
</script>
